/** @file Drops the entries a direction set's count and layout no longer allow (INFO lists them). */
import type { Draft } from 'immer';
import { names } from '@pose2d/format/names';
import type { DirectionsDoc } from '@pose2d/format/types';
import type { CommandContext } from '../commandContext';
import { allowedDirs } from './allowedDirs';

/** Removes entries outside allowedDirs(set.count, set.layout4) and pushes one INFO warning naming them. */
export function pruneEntries(set: Draft<DirectionsDoc>, ctx: CommandContext): void {
  const allowed = allowedDirs(set.count, set.layout4);
  const dropped = names.DIRS.filter((dir) => set.entries[dir] !== undefined && !allowed.includes(dir));
  if (dropped.length === 0) return;
  for (const dir of dropped) Reflect.deleteProperty(set.entries, dir);
  const kind = set.count === 8 ? '8-direction' : `4-direction ${set.layout4 ?? 'diagonal'}`;
  ctx.warnings.push({ code: 'INFO', message: `removed ${dropped.join(', ')}: a ${kind} set cannot hold them`, params: { dropped: dropped.join(',') }, path: 'directions.entries' });
}
